import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DialogContainer, DialogTitle, DialogBody, DialogActions } from '../../../common';
import { formatCurrency, formatDate } from '../../../utils/formatUtils';

const ProcessResultsDialog = ({ open, onClose, data }) => {
  if (!data) return null;

  const { invoices = [], updated_coupons = [], errors = [] } = data;

  const renderInvoicesList = () => (
    <List dense>
      {invoices.length > 0 ? (
        invoices.map((invoice, index) => (
          <ListItem key={`invoice-${index}`}>
            <ListItemText
              primary={invoice.subscriber_names}
              secondary={`Total: ${formatCurrency(invoice.to_total)}`}
            />
          </ListItem>
        ))
      ) : (
        <ListItem>
          <ListItemText primary="No se crearon facturas" />
        </ListItem>
      )}
    </List>
  );

  const renderCouponsList = () => (
    <List dense>
      {updated_coupons.length > 0 ? (
        updated_coupons.map((coupon, index) => (
          <ListItem key={`coupon-${index}`}>
            <ListItemText
              primary={`Contrato: ${coupon.contract_number || 'N/A'}`}
              secondary={`Cuota(s): ${coupon.coupon?.fee_number1 || coupon.fee_number1 || 'N/A'}${
                coupon.coupon?.fee_number2 || coupon.fee_number2
                  ? ' - ' + (coupon.coupon?.fee_number2 || coupon.fee_number2)
                  : ''
              }, Fecha de pago: ${formatDate(
                coupon.coupon?.cancellation_date || coupon.cancellation_date,
                { fallback: '' }
              )}`}
            />
          </ListItem>
        ))
      ) : (
        <ListItem>
          <ListItemText primary="No se actualizaron cupones" />
        </ListItem>
      )}
    </List>
  );

  const renderErrorsList = () => (
    <List dense>
      {errors.length > 0 ? (
        errors.map((error, index) => (
          <ListItem key={`error-${index}`}>
            <ListItemText
              primary={`Contrato: ${error.contract?.contract_number || 'N/A'} - ${
                error.contract?.subscribers || 'N/A'
              }`}
              secondary={`Cuota(s): ${error.coupon?.fee_number1 || 'N/A'}${
                error.coupon?.fee_number2 ? ' - ' + error.coupon.fee_number2 : ''
              }, Error: ${error.mensaje}`}
            />
          </ListItem>
        ))
      ) : (
        <ListItem>
          <ListItemText primary="No se encontraron errores" />
        </ListItem>
      )}
    </List>
  );

  return (
    <DialogContainer open={open} onClose={onClose} size="medium">
      <DialogTitle>Resultados del procesamiento</DialogTitle>

      <DialogBody>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: 'whitesmoke' }}>
            <Typography variant="h6">Facturas creadas ({invoices.length})</Typography>
          </AccordionSummary>
          <AccordionDetails>{renderInvoicesList()}</AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Cupones actualizados ({updated_coupons.length})</Typography>
          </AccordionSummary>
          <AccordionDetails>{renderCouponsList()}</AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: 'whitesmoke' }}>
            <Typography variant="h6">Errores ({errors.length})</Typography>
          </AccordionSummary>
          <AccordionDetails>{renderErrorsList()}</AccordionDetails>
        </Accordion>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={null} />
    </DialogContainer>
  );
};

export default ProcessResultsDialog;
